import React, { CSSProperties, useState } from "react";
import "./generic.dropdown.scss";
import { SimpleOutsideClick } from "@me8eon/outside_click";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";

export type DropdownOption = {
    name: string
    value?: string
    icon?: string
}

export type GenericDropdownProps = {
    label: string
    options: DropdownOption[] | string[]
    icon: string
    iconOnOpen?: string
    dropdownStyle?: CSSProperties
    dropdownHeaderStyle?: CSSProperties
    isWidthRestricted?: boolean
    selectedOps?: string
    rootId: string
    closeOnSelect?: boolean
    maxWidth?: string
    showSelectTick?: boolean
    isForHeader?: boolean
    clickHandler: (clickedItem: any, index?: number) => void
}
export type GenericDropdown = (props: GenericDropdownProps) => React.ReactNode

export const GenericDropdown: GenericDropdown = ({ label, icon, iconOnOpen, dropdownStyle, dropdownHeaderStyle, options, selectedOps, maxWidth, rootId, clickHandler, closeOnSelect = true, showSelectTick = true, isForHeader = true, isWidthRestricted = true }: GenericDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const t = useTranslation();

    const onLanguageChange = (clickedItem: any, index: number) => {
        closeOnSelect && setIsOpen(false);
        clickHandler(clickedItem, index)
    }

    return (
        <SimpleOutsideClick onClickOutside={() => setIsOpen(false)}>
            <div className="dropdown-overlay" id={rootId}>
                <button
                    data-testid="languageSwitchIcon"
                    className={`action-wrapper ${!isOpen && isForHeader ? "header-hover-effect" : ""}`}
                    aria-label="Navigate to "
                    role="menuitem"
                    tabIndex={0}
                    onClick={() => setIsOpen(!isOpen)}
                    title={label}
                >
                    <EonUiIcon
                        title={label}
                        size="normal"
                        name={icon}
                    />
                </button>
                <div className="overlay-wrapper" data-testid="languageSwitchPopup">
                    <div className={`dropdown-body ${isOpen ? "open" : ""} ${isWidthRestricted ? "restrict-width" : ""}`}>
                        <div
                            className="action-wrapper"
                            style={{ ...dropdownHeaderStyle }}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span> {isOpen && label} </span>
                            <EonUiIcon
                                title={label}
                                size="normal"
                                name={iconOnOpen ? iconOnOpen : icon}
                            />
                        </div>
                        {options.map((option, index: number) => {
                            if (typeof option === "string") {
                                option = { name: option, value: option }
                            }
                            const isSelected = option.value === selectedOps || option.name === selectedOps || index.toString() === selectedOps;
                            return (
                                <button
                                    data-testid={`${option.name}-${index}`}
                                    key={`key-${option.name}-${index}`}
                                    className={`dropdown-item ${isSelected ? "dropdown-item--highlight" : ""}`}
                                    style={{ ...dropdownStyle }}
                                    onClick={() => onLanguageChange(option.value || option.name, index)}
                                    title={option.name}
                                >
                                    <div className="option-val" style={{
                                        maxWidth: maxWidth,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {option.name}
                                    </div>
                                    {
                                        isSelected && showSelectTick && (
                                            <EonUiIcon
                                                size="normal"
                                                className="turquoise-icon"
                                                name="radio_checkbox_tick"
                                            />
                                        )
                                    }
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div >
        </SimpleOutsideClick >
    )
};